<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="tablePath">{{ tablePathText }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <template v-if="showErrorMsg">
      <error-panel v-if="detailErrorMsg" :message="detailErrorMsg" show-back/>
    </template>
    <template v-else>
    <layout-panel>
      <span slot="header">开票申请 - 详情</span>
      <template slot="tools">
        <el-button size="mini"
                   type="primary"
                   @click="generatePdf"
                   :loading="downloadingPdf"
                   style="margin-left: 20px">生成PDF
        </el-button>
      </template>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <div class="medium"
             style="width: auto">
          <!-- 开票详情 -->
          <InvoiceApplyInfo :form="form"/>

          <!-- 开票发票列表 -->
          <InvoiceDetailsList :form="form"/>

          <!-- 开票状态 -->
          <InvoiceStatusLayout :form="form"/>
        </div>
      </el-form>
    </layout-panel>

    <!-- 红冲相关信息 -->
    <layout-panel v-if="showRedFlushPanel()">
      <span slot="header">退票/红冲信息</span>
      <InvoiceReturnLayout :form="form"/>
    </layout-panel>

    <!-- 预收款开票抵扣申请信息 -->
    <layout-panel v-if="form.deduction_detail.length > 0">
      <span slot="header">抵扣详情</span>
      <InvoiceDeductLayout :form="form"/>
    </layout-panel>

    <!-- 回款信息 -->
    <layout-panel v-if="showCollectPanel()">
      <span slot="header">回款详情</span>
      <InvoiceCollectionLayout :form="form" :isFromFinance="$route.meta.isFinancePage"/>
    </layout-panel>

    <!-- 发票拆分详情 -->
    <layout-panel v-if="form.split_list.length > 0">
      <span slot="header">发票拆分详情</span>
      <InvoiceTicketSplitDetail :dataSource="form.split_list"/>
    </layout-panel>

    <el-button type="primary"
               size="medium"
               @click="backToTablePage()">返 回
    </el-button>
    <el-button type="warning"
               size="medium"
               v-if="isShowReviewBtn()"
               @click="redirectReviewPage()">审 批
    </el-button>
    </template>
  </div>
</template>

<script>
import downloadJS from '@/vendor/download'
import { getToken } from '@utils/auth'
import 'viewerjs/dist/viewer.css'

import InvoiceApplyInfo from '../components/InvoiceApplyInfo'
import InvoiceCollectionLayout from '../components/InvoiceCollectionLayout'
import InvoiceDeductLayout from '../components/InvoiceDeductLayout'
import InvoiceDetailsList from '../components/InvoiceDetailsList'
import InvoiceReturnLayout from '../components/InvoiceReturnLayout'
import InvoiceStatusLayout from '../components/InvoiceStatusLayout'
import InvoiceTicketSplitDetail from '../components/ticket-split/InvoiceTicketSplitDetail'
import ErrorPanel from '@components/ErrorPanel.vue'

export default {
  components: {
    ErrorPanel,
    InvoiceApplyInfo,
    InvoiceDetailsList,
    InvoiceStatusLayout,
    InvoiceReturnLayout,
    InvoiceCollectionLayout,
    InvoiceDeductLayout,
    InvoiceTicketSplitDetail,
  },
  data () {
    return {
      downloadingPdf: false,
      showErrorMsg: true,
      detailErrorMsg: '',
      form: {
        deduction_detail: [],
        attached_file: [],
        log: [],
        cc: [],
        red_flush_attached_file: [],
        detail: [],
        received_details: [],
        split_list: [],
      },
    }
  },
  async created () {
    await this.setForm()
  },
  watch: {},
  computed: {
    ...Vuex.mapState({
      user: state => state.login.user,
    }),
    tablePathText () {
      return this.$route.meta.isFinancePage ? '开票审批' : '开票管理'
    },
    tablePath () {
      if (this.$route.meta.isFinancePage) {
        return '/invoice-apply/approve/table'
      }
      return '/invoice-apply/table'
    },
  },
  methods: {
    ...Vuex.mapActions([]),
    setForm () {
      const params = {id: this.$route.params.id}
      params.forFinance = this.$route.meta.isFinancePage ? 1 : 0

      request('getInvoiceApplyDetail', params).then(async ({data}) => {
        data = await this.setProjectBudget(data)
        data = this.setReceivedList(data)
        data.setProjectBudgetFinish = true
        this.form = data
        this.showErrorMsg = false
      }).catch((e) => {
        this.detailErrorMsg = String(e).replace(/^Error:\s*/i, '')
        this.showErrorMsg = true
      })
    },
    backToTablePage () {
      this.$router.push(this.tablePath)
    },
    isShowReviewBtn () {
      return this.current_approver + '' === this.user.id + ''
    },
    redirectReviewPage () {
      if (this.form.status + '' === '1') {
        this.$router.push(`/invoice-apply/review/${this.$route.params.id}?type=approve&from=apply&time=1`)
      }
    },
    generatePdf () {
      this.downloadingPdf = true
      downloadJS(request.items.downloadInvoiceDetailPdf({id: this.$route.params.id}), false, false, {
        'SJ-Auth-Token': getToken()
      }, () => {
        this.downloadingPdf = false
      })
    },
    // 是否展示回款信息数据
    showCollectPanel () {
      // 6 已开票;7 已签收;8 待作废;9 已作废;10 已开红冲
      return [6, 7, 8, 9, 10].includes(this.form.status)
    },
    showRedFlushPanel () {
      return [8, 9, 10, 11, 13, 14, 16, 17].includes(this.form.status)
    },
    async setProjectBudget (source) {
      for (let i = 0; i < source.detail.length; i++) {
        const item = source.detail[i]
        // 获取项目成本和项目预算
        item.budget = item.cost = item.complete_rate = ''
        if (item.projectid > 0) {
          await request.common('getInvoiceProjectFinance', {id: item.projectid}).then(({data}) => {
            item.budget = _.round(Number(data.total_budget), 2)
            item.cost = _.round(Number(data.cost), 2)
            if (data.complete_rate > 0) {
              item.complete_rate = _.round(Number(data.complete_rate), 2)
            }
          }).catch(() => {})
        }
        this.$set(source.detail, i, item)
      }
      return source
    },
    setReceivedList (data) {
      data.received_details = data.received_details.map(item => {
        return {
          ...item,
          ...data.detail.find(option => option.id === item.receipt_apply_detail_id),
          id: item.id,
          created_at: item.created_at,
        }
      })
      return data
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/pages/InvoiceApplyNewDetail.vue